import { render } from "./StoreDatabaseView.vue?vue&type=template&id=50640088&scoped=true&ts=true"
import script from "./StoreDatabaseView.vue?vue&type=script&lang=ts"
export * from "./StoreDatabaseView.vue?vue&type=script&lang=ts"

import "./StoreDatabaseView.vue?vue&type=style&index=0&id=50640088&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50640088"]])

export default __exports__